import { render } from "./ScheduleReceptionBoard.vue?vue&type=template&id=f9f27148&scoped=true"
import script from "./ScheduleReceptionBoard.vue?vue&type=script&lang=js"
export * from "./ScheduleReceptionBoard.vue?vue&type=script&lang=js"

import "./ScheduleReceptionBoard.vue?vue&type=style&index=0&id=f9f27148&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f27148"]])

export default __exports__